import { MakeCall } from './createMakeCall';
import { FavoriteListing } from './types/FavoriteListing';

export type RemoveFavoriteListingCall = (
  listingId: number,
) => Promise<{ data: FavoriteListing }>;

const removeFavoriteListing = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/listing/${listingId}/favorite`);
export { removeFavoriteListing };
